import ValueOf from 'types/valueOf';

export interface Object {
  entriesTS<K extends string | number | symbol, V>(object: Record<K, V>): [K, V][];
}

// eslint-disable-next-line no-extend-native
Object.defineProperty(Object.prototype, 'entriesTS', {
  enumerable: false,
  value: function <K extends string | number | symbol, V>(object: Record<K, V>) {
    return Object.entries(object) as [keyof typeof object, ValueOf<typeof object>][];
  },
});
